import React, { useState, useEffect, useRef } from "react";
import "./TablaPersonal.scss";
import { getUnidades, getLicencias, updatePersonal, getInactiveOperators, getActiveOperators, getOperadoresSinUsuarioAsignado, getUsuarios, getLineasTelefono, getTodosLosUsuarios, addUsuarios, updateUsuarios } from "./integracion";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";
import TestForm from "../FormularioAltas/TestForm";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getClientes } from "../../admin/Bitacoras/integracion";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import { formateoBasico } from "../../../utilidades/formateos";


const TablaPersonal = ({ data, onEditar, unitTypes, licenseTypes, onCreate, showActives, onToggleActives, setVisible,setVisibleEditar, llenarModal }) => {
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [nameInput, setNameInput] = useState('');
    const [dataUsers, setData] = useState(data || []);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const opTable = useRef(null);
    useEffect(() => {
        const parseFecha = (v) => {
            if (!v) return null;
            // dd/mm/yyyy
            const m = String(v).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (m) {
                const [, dd, mm, yyyy] = m;
                const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
                return isNaN(d.getTime()) ? null : d;
            }
            const d = new Date(v);
            return isNaN(d.getTime()) ? null : d;
        };

        // Precalcular timestamps una sola vez
        const enriched = (data || []).map(row => {
            const di = parseFecha(row.INGRESO);
            const db = parseFecha(row.BAJA);
            return {
                ...row,
                INGRESO_TS: di ? di.getTime() : null,
                BAJA_TS: db ? db.getTime() : null
            };
        });
        setData(enriched);
    }, [data]);

    const openEditDialog = (id) => {
        setEditingId(id ?? null);
        setEditDialogOpen(true);
    };

    const closeEditDialog = () => {
        setEditDialogOpen(false);
        setEditingId(null);
        // Opcional: aquí puedes refrescar la tabla si el formulario guarda cambios
        // e.g. onRefresh && onRefresh();
    };

    const exportColumns = [
        { header: "ID", field: "ID" },
        { header: "Nombre", field: "NOMBRE" },
        { header: "Teléfono", field: "TELEFONO" },
        { header: "Fecha Nac.", field: "FEC_NAC" },
        { header: "ID Unidad", field: "ID_UNIDAD" },
        { header: "Tipo Unidad", field: "TIPO_UNIDAD" },
        { header: "Usuario", field: "USUARIO" },
        { header: "Ingreso", field: "INGRESO" },
        { header: "Baja", field: "BAJA" },
        { header: "Escolaridad", field: "ESCOLARIDAD" },
        { header: "Dirección", field: "DIRECCION" },
        { header: "Referencia", field: "REFERENCIA" },
        { header: "Municipio", field: "MUNICIPIO" },
        { header: "Email", field: "EMAIL" },
        { header: "No. Licencia", field: "NUMERO_LICENCIA" },
        { header: "Tipo Licencia", field: "TIPO_LICENCIA" },
        { header: "Venc. Licencia", field: "VENCIMIENTO_LICENCIA" },
        { header: "Apto Médico", field: "APTO_MEDICO" },
    ];

    const navigate = useNavigate();

    const toast = useRef(null);


    const show = () => {
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Se han guardado los cambios correctamente' });
    };


    const exportCSV = () => {
        opTable.current.exportCSV();
    };


    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">

                <span className="p-input-icon-left">
                    <i className="pi pi-search" style={{ marginLeft: '10px' }} />
                    <InputText
                        value={globalFilterValue}
                        onChange={(e) => setGlobalFilterValue(e.target.value)}
                        placeholder="Buscar por Nombre"
                        style={{ paddingLeft: '35px' }}
                    />
                </span>

                <Button
                    type="button"
                    icon={showActives ? "pi pi-user-minus" : "pi pi-user-plus"}
                    label={showActives ? "Ver Inactivos" : "Ver Activos"}
                    onClick={onToggleActives}
                    className="p-button-secondary"
                    style={{ marginLeft: '20px' }}
                />

                <Button
                    type="button"
                    icon="pi pi-file-excel"
                    label="Exportar Excel"
                    onClick={exportCSV}
                    className="p-button-success"
                    style={{ marginLeft: '20px' }}
                />
                <Button
                    type="button"
                    icon="pi pi-user"
                    label="Crear Usuario"
                    onClick={() => { setVisible(true) }}
                    className="p-button-primary"
                    style={{ marginLeft: '20px' }}
                />
                {/*  <Button
                    type="button"
                    icon="pi pi-file-pdf"
                    label="PDF"
                    onClick={exportPDF}
                    className="p-button-danger"
                />

                <Button
                    type="button"
                    icon="pi pi-print"
                    label="Imprimir"
                    onClick={printTable}*/}

            </div>
        );
    };

    const printTable = () => {
        const rows = dataUsers || [];
        const style = `
          <style>
            table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 12px; }
            th, td { border: 1px solid #ccc; padding: 6px 8px; text-align: left; }
            th { background: #f5f5f5; }
            h2 { font-family: Arial, sans-serif; }
          </style>
        `;
        const thead = `<thead><tr>${exportColumns.map(c => `<th>${c.header}</th>`).join("")}</tr></thead>`;
        const tbody = `<tbody>${rows.map(r => `<tr>${exportColumns.map(c => `<td>${r?.[c.field] ?? ""}</td>`).join("")
            }</tr>`).join("")
            }</tbody>`;
        const html = `${style}<h2>Personal (${showActives ? "Activos" : "Inactivos"})</h2><table>${thead}${tbody}</table>`;

        const win = window.open("", "PRINT", "height=700,width=1000");
        if (win) {
            win.document.write(html);
            win.document.close();
            win.focus();
            win.print();
        }
    };

    const exportPDF = () => {
        const rows = dataUsers || [];
        const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });
        doc.text(`Personal - ${showActives ? "Activos" : "Inactivos"}`, 40, 40);
        autoTable(doc, {
            startY: 60,
            head: [exportColumns.map(c => c.header)],
            body: rows.map(r => exportColumns.map(c => r?.[c.field] ?? "")),
            styles: { fontSize: 8, cellPadding: 4 },
            headStyles: { fillColor: [33, 150, 243] }
        });
        doc.save(`personal_${showActives ? "activos" : "inactivos"}.pdf`);
    };

    const header = renderHeader();


    // This function will be passed to the DataTable column
    const accionesTemplateUsuario = (rowData) => {
        return (
            <div className="action-buttons">
                <Button
                    label=""
                    rounded outlined
                    icon="pi pi-pencil"
                    severity=""
                    onClick={() => { setVisibleEditar(true); llenarModal(rowData) }}

                />
            </div>
        );
    };
    const accionesTemplate = (rowData) => {
        return (
            <div className="action-buttons">
                <Button
                    label=""
                    rounded outlined
                    icon="pi pi-pencil"
                    severity="warning"
                    onClick={() => openEditDialog(rowData.ID)}

                />
            </div>
        );
    };
    return (
        <div className="table-container-th-TP">
            <DataTable
                ref={opTable}
                value={dataUsers} className="custom-table-th" globalFilter={globalFilterValue}
                header={header}
                emptyMessage="No se encontraron operadores."
                scrollable
                showGridlines
                scrollWidth="100%"
                scrollHeight="calc(100vh - 150px)"
                virtualScrollerOptions={{ itemSize: 50 }}

            >
                <Column header="Chofer" body={accionesTemplate}></Column>
                <Column header="Usuario" body={accionesTemplateUsuario}></Column>
                <Column field="ID" header="ID" sortable></Column>
                <Column field="NOMBRE" header="Nombre" style={{ minWidth: '200px' }}></Column>
                <Column field="TELEFONO" header="Teléfono"></Column>
                <Column field="FEC_NAC" header="Fecha Ncimiento"></Column>
                <Column field="ID_UNIDAD" header="ID Unidad"></Column>
                <Column field="TIPO_UNIDAD" header="Tipo Unidad"></Column>
                <Column field="USUARIO" header="Usuario"></Column>
                <Column field="INGRESO" dataType="date" style={{ minWidth: '96px' }} header="Ingreso" sortable sortField="INGRESO_TS"></Column>
                <Column field="BAJA" header="Baja" sortable sortField="BAJA_TS" style={{ minWidth: '88px' }}></Column>
                <Column field="ESCOLARIDAD" header="Escolaridad"></Column>
                <Column field="DIRECCION" header="Dirección" style={{ minWidth: '100px' }}></Column>
                <Column field="REFERENCIA" header="Referencia" style={{ minWidth: '300px' }}></Column>
                <Column field="MUNICIPIO" header="Municipio"></Column>
                <Column field="EMAIL" header="Email" style={{ minWidth: '322px' }}></Column>
                <Column field="AFILIACION" header="IMSS" style={{ minWidth: '100px' }}></Column>
                <Column field="RFC" header="RFC" style={{ minWidth: '100px' }}></Column>
                <Column field="NUMERO_LICENCIA" header="No. licencia" style={{ minWidth: '96px' }}></Column>
                <Column field="TIPO_LICENCIA" header="Tipo Licencia" style={{ minWidth: '100px' }}></Column>
                <Column field="VENCIMIENTO_LICENCIA" dataType="date" header="Vencimiento Licencia" style={{ minWidth: '100px' }}></Column>

                <Column field="APTO_MEDICO" dataType="date" header="Apto Medico" style={{ minWidth: '100px' }}></Column>

            </DataTable>

            <Dialog
                header={editingId ? "Editar Usuario" : "Nuevo Usuario"}
                visible={editDialogOpen}
                modal
                className="dialog-no-padding"
                style={{ width: '90vw', height: '90vh', maxWidth: '1400px' }}
                breakpoints={{ '1200px': '90vw', '641px': '98vw' }}
                contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
                onHide={closeEditDialog}
            >
                <TestForm usuarioId={editingId} onClose={closeEditDialog} />
            </Dialog>


        </div>
    );
};
export default function PersonalView() {
    const [users, setUsers] = useState([]);
    const [unitTypes, setUnitTypes] = useState([]);
    const [licenseTypes, setLicenseTypes] = useState([]);
    const [showActives, setShowActives] = useState(true);
    const navigate = useNavigate();
    // funcionalidad de modal de agregar usuario
    const [operadoresSinUsuario, setOperadoresSinUsuario] = useState([])
    const [operadorSinUsuario, setOperadorSinUsuario] = useState(null)
    const [usuarios, setUsuarios] = useState([])
    const [visible, setVisible] = useState(false);
    const [visibleEditar, setVisibleEditar] = useState(false);
    const [clientes, setClientes] = useState([]);

    const [cliente, setCliente] = useState({ name: "SUMA TE LLEVA", code: 5 });
    const [clientePlaceHolder, setClientePlaceHolder] = useState(null);
    const [clienteID, setClienteID] = useState(null);
    const [nombre, setNombre] = useState("");
    const [passMonitor, setPassMonitor] = useState("");
    const [passSumaEnLinea, setPassSumaEnLinea] = useState("");
    const [email, setEmail] = useState("");
    const [puesto, setPuesto] = useState(null);
    const [fechaNacimiento, setFechaNacimiento] = useState("");
    const [activo, setActivo] = useState(false);
    const [acceso, setAcceso] = useState(false);
    const [esOperador, setEsOperador] = useState({ name: "Operativo", code: 1 });
    const [lineasTelefonos, setLineasTelefonos] = useState([]);
    const [lineasTelefono, setLineasTelefono] = useState({ code: -1, name: "Sin linea" });
    const [lineasTelefonoPlaceholder, setLineasTelefonoPlaceholder] = useState(null);
    const [lineasTelefonoID, setLineasTelefonoID] = useState(null);
    const [idUsuario, setIdUsuario] = useState(null);
    const [todosLosUsuarios, setTodosLosUsuarios] = useState([]);
    const [todosLosUsuario, setTodosLosUsuario] = useState(null);
   
    const administrativoOperativo = [
        { name: "Operativo", code: 1 },
        { name: "Administrativo", code: 2 }
    ]
    const llenarModal = (rowData) => {

        setNombre(rowData.NOMBRE_USUARIO)
        setPassMonitor(rowData.PASS_MONITOR)
        setPassSumaEnLinea(rowData.PASS_SUMA_EN_LINEA)
        setEmail(rowData.EMAIL_USUARIO)
        setFechaNacimiento(formateoBasico(rowData.FECHA_NACIMIENTO))
        setLineasTelefonoPlaceholder(rowData.TELEFONO)
        setLineasTelefonoID(rowData.TELEFONO_ID)
        setActivo(rowData.ACTIVO )
        setAcceso(rowData.ACCESO )
        setClientePlaceHolder(rowData.NOMBRE_EMPRESA)
        setClienteID(rowData.ID_EMPRESA)
        setEsOperador(rowData.ES_OPERADOR == 0 ? { name: "Administrativo", code: 2 } : { name: "Operativo", code: 1 })
        setIdUsuario(rowData.USUARIO)
        setCliente(null)
        setLineasTelefono(null)
    }
    useEffect(() => {
        getOperadoresSinUsuarioAsignado(setOperadoresSinUsuario)
        getUsuarios(setUsuarios)
        getClientes(setClientes)
        getLineasTelefono(setLineasTelefonos)
        getTodosLosUsuarios(setTodosLosUsuarios)
    }, [])
    useEffect(() => {
        if (visible == true) {
            setCliente({ name: "SUMA TE LLEVA", code: 5 })
            setLineasTelefono({ code: -1, name: "Sin linea" })

        }
    }, [visible])

    const agregarUsuario = async () => {
        if (esOperador.code == 1) {
            if (email && lineasTelefono && operadorSinUsuario) {
                const params = {
                    id_cliente: cliente.code,
                    email: email,
                    celular: lineasTelefono?.code,
                    id_operador: operadorSinUsuario.code
                }

                setVisible(false)
                await addUsuarios(params)
                await getUsuarios(setUsuarios)
                await getOperadoresSinUsuarioAsignado(setOperadoresSinUsuario)
                await getLineasTelefono(setLineasTelefonos)
                await getActiveOperators(setUsers)
                limpiarCampos()
            }
            else {
                alert("Faltan campos por rellenar")
            }
        }
        // else {
        //     if (email && lineasTelefono && cliente && nombre && fechaNacimiento) {
        //         const params = {
        //             id_cliente: cliente.code,
        //             nombre: nombre,
        //             pass_monitor: passMonitor,
        //             email: email,
        //             celular: lineasTelefono?.code,
        //             fecha_nacimiento: fechaNacimiento,
        //             es_operador: esOperador.code,
        //             pass_suma_en_linea: passSumaEnLinea,
        //             id_usuario_permiso: todosLosUsuario ? todosLosUsuario.code : 0
        //         }



        //         setVisible(false)
        //         await addUsuarios(params)
        //         await getUsuarios(setUsuarios)
        //         await getOperadoresSinUsuarioAsignado(setOperadoresSinUsuario)
        //         await getLineasTelefono(setLineasTelefonos)
        //         await getActiveOperators(setUsers)
        //         limpiarCampos()
        //     }
        //     else {
        //         alert("Faltan campos por rellenar")
        //     }
        // }

    }


    const limpiarCampos = () => {
        setNombre("")
        setPassMonitor("")
        setPassSumaEnLinea("")
        setEmail("")
        // setPuesto("")
        setFechaNacimiento("")
        setLineasTelefono("")
        setActivo(false)
        setAcceso(false)
        setClienteID(null)
        setClientePlaceHolder('')
        setLineasTelefonoID(null)
        setLineasTelefonoPlaceholder('')
        setTodosLosUsuario(null)
    }

    const actualizarUsuario = async () => {
        // if (esOperador.code == 2) {

        //     if (nombre && email && fechaNacimiento) {
        //         const params = {
        //             id_cliente: cliente ? cliente.code : clienteID,
        //             id_usuario: idUsuario,
        //             nombre: nombre,
        //             pass_monitor: passMonitor,
        //             email: email,
        //             celular: lineasTelefono ? lineasTelefono.code == -1 ? -1 : lineasTelefono.code : lineasTelefonoID,
        //             fecha_nacimiento: fechaNacimiento,
        //             es_operador: esOperador.code,
        //             pass_suma_en_linea: passSumaEnLinea,
        //             activo: activo == true ? '1' : '0'

        //         }
              
        //         setVisibleEditar(false)

        //         await updateUsuarios(params)
        //         await getUsuarios(setUsuarios)
        //         await getOperadoresSinUsuarioAsignado(setOperadoresSinUsuario)
        //         await getLineasTelefono(setLineasTelefonos)
        //         await getActiveOperators(setUsers)
        //         limpiarCampos()
        //     }
        //     else {
        //         alert("Faltan campos por rellenar")
        //     }
        // }
        // else {
            if (email) {
                const params = {
                    id_usuario: idUsuario,
                    email: email,
                    celular: lineasTelefono ? lineasTelefono.code == -1 ? -1 : lineasTelefono.code : lineasTelefonoID,
                    // puesto: puesto,
                    activo: activo == true ? '1' : '0',
                }
          

                setVisibleEditar(false)
                await updateUsuarios(params)
                await getUsuarios(setUsuarios)
                await getOperadoresSinUsuarioAsignado(setOperadoresSinUsuario)
                await getLineasTelefono(setLineasTelefonos)
                await getActiveOperators(setUsers)
                limpiarCampos()
            }
            else {
                alert("Faltan campos por rellenar")
            }
        // }

    }
    // ----------------------------------------------------------------------------------------------------------------------------------------------

    const loadUsers = async (activos) => {
        if (activos) {
            // Activos
            await getActiveOperators(setUsers);
        } else {
            // Inactivos
            await getInactiveOperators(setUsers);
        }
    };

    useEffect(() => {
        loadUsers(showActives);
        getUnidades(setUnitTypes)
        getLicencias(setLicenseTypes);
    }, []); // carga inicial

    const handleToggleActives = () => {
        const next = !showActives;
        setShowActives(next);
        loadUsers(next);
    };

    const handleEditar = (ID) => {
        navigate("/th/detallePersonal", { state: { ID } });
    };

    const handleCreate = () => {
        navigate("/th/detallePersonal")
    }



    return (
        <div>
            {users.length === 0 ? (
                <div className="loading-container">
                    <div className="loading-content">
                        <ProgressSpinner
                            style={{ width: '60px', height: '60px' }}
                            strokeWidth="8"
                            fill="transparent"
                            animationDuration=".8s"
                        />
                        <p>{showActives ? "Cargando usuarios activos" : "Cargando usuarios inactivos"}</p>
                    </div>
                </div>
            ) : (
                <TablaPersonal
                    data={users}
                    setVisible={setVisible}
                    onEditar={handleEditar}
                    unitTypes={unitTypes}
                    licenseTypes={licenseTypes}
                    onCreate={handleCreate}
                    showActives={showActives}
                    onToggleActives={handleToggleActives}
                    llenarModal={llenarModal}
                    setVisibleEditar={setVisibleEditar}
                />
            )}
            <Dialog
                header="Agregar Usuario"
                className="dialog"
                visible={visible}
                style={{ width: '70vw', maxWidth: '800px'}}
                breakpoints={{ '1200px': '80vw', '768px': '90vw', '641px': '98vw' }}
                onHide={() => { if (!visible) return; setVisible(false); limpiarCampos() }}
                draggable={false}
            >
                <div className="modalInputs">
                    {/* Primera fila - Tipo de usuario (ocupa toda la fila) */}
                    {/* <div className="input-container full-width" data-required="true">
                        <InputLista
                            options={administrativoOperativo}
                            value={esOperador}
                            onChange={(e) => { setEsOperador(e.value) }}
                            titulo={"Tipo de Usuario"}
                        />
                    </div> */}

                    {/* Operadores sin usuario - Solo para operativos */}
                    {esOperador.code == 1 && (
                        <div className="input-container full-width conditional-field" data-required="true">
                            <InputLista
                                options={operadoresSinUsuario}
                                value={operadorSinUsuario}
                                onChange={(e) => { setOperadorSinUsuario(e.value) }}
                                titulo={"Operadores sin usuario"}
                            />
                        </div>
                    )}

                    {/* Segunda fila - Empresa y Nombre */}
                    {/* <div className="input-container" data-required="true">
                        <InputLista
                            options={clientes}
                            value={cliente}
                            onChange={(e) => { setCliente(e.value) }}
                            titulo={"Empresa"}
                        />
                    </div> */}

                    {/* {esOperador.code == 2 ? (
                        <div style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }} className="input-container conditional-field" data-required="true">
                            <label htmlFor="nombre-input"> <span style={{ color: "red" }}>*</span> Nombre Completo </label>
                            <InputText
                                id="nombre-input"
                                value={nombre}
                                onChange={(e) => { setNombre(e.target.value) }}
                                placeholder="Ingrese el nombre completo"
                            />
                        </div>
                    ) : (
                        <div></div> // Espacio vacío para mantener el grid
                    )} */}

                    {/* Tercera fila - Email y Celular */}
                    <div style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }} className="input-container" data-required="true">
                        <label htmlFor="email-input"> <span style={{ color: "red" }}>*</span>Correo Electrónico </label>
                        <InputText
                            id="email-input"
                            type="email"
                            value={email}
                            onChange={(e) => { setEmail(e.target.value) }}
                            placeholder="usuario@ejemplo.com"
                        />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }} className="input-container" data-required="true">
                        <InputLista
                            options={lineasTelefonos}
                            value={lineasTelefono}
                            onChange={(e) => { setLineasTelefono(e.value) }}
                            titulo={"Número de Celular"}
                        />
                    </div>

                    {/* Campos adicionales para administrativos */}
                    {esOperador.code == 2 && (
                        <>
                            {/* Separador visual */}
                            <div className="section-divider"></div>

                            {/* Cuarta fila - Contraseñas */}
                            <div className="input-container conditional-field" style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }}>
                                <label htmlFor="password-plataformas-input">Password Plataformas</label>
                                <InputText
                                    id="password-plataformas-input"
                                    type="password"
                                    value={passMonitor}
                                    onChange={(e) => { setPassMonitor(e.target.value) }}
                                    placeholder="Contraseña para plataformas"
                                />
                            </div>

                            <div className="input-container conditional-field" style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }}>
                                <label htmlFor="password-suma-input">Password Suma en Línea</label>
                                <InputText
                                    id="password-suma-input"
                                    type="password"
                                    value={passSumaEnLinea}
                                    onChange={(e) => { setPassSumaEnLinea(e.target.value) }}
                                    placeholder="Contraseña para Suma en Línea"
                                />
                            </div>

                            {/* Quinta fila - Fecha nacimiento y permisos */}
                            <div className="input-container conditional-field" data-required="true">
                                <InputCalendario
                                    obligatorio
                                    titulo={'Fecha de Nacimiento'}
                                    value={fechaNacimiento}
                                    onChange={(e) => { setFechaNacimiento(e.target.value) }}
                                />
                            </div>

                            <div className="input-container conditional-field" >
                                <InputLista
                                    options={todosLosUsuarios}
                                    value={todosLosUsuario}
                                    onChange={(e) => { setTodosLosUsuario(e.value) }}
                                    titulo={"Copiar permisos de:"}
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="modal-buttons-tablaPersonal">
                    <Button
                        className="p-button-secondary"
                        icon="pi pi-times"
                        onClick={() => { setVisible(false); limpiarCampos() }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        icon="pi pi-check"
                        onClick={() => { agregarUsuario() }}
                        disabled={
                            !email ||
                            !cliente ||
                            !lineasTelefono ||
                            (esOperador.code == 2 && (!nombre || !fechaNacimiento)) ||
                            (esOperador.code == 1 && !operadorSinUsuario)
                        }
                    >
                        Guardar Usuario
                    </Button>
                </div>
            </Dialog>
            <Dialog 
                header="Editar Usuario" 
                className="dialog" 
                visible={visibleEditar} 
                style={{ width: '70vw', maxWidth: '800px', padding:"0px !important" }}
                breakpoints={{ '1200px': '80vw', '768px': '90vw', '641px': '98vw' }}
                onHide={() => { if (!visibleEditar) return; setVisibleEditar(false); limpiarCampos() }}
                draggable={false}
            >
                <div className="modalInputs">
                    {/* Primera fila - Empresa y Estado Activo */}
                    {/* <div className="input-container">
                        <InputLista 
                            placeholder={clientePlaceHolder} 
                            options={clientes} 
                            value={cliente} 
                            onChange={(e) => { setCliente(e.value) }} 
                            titulo={"Empresa"}
                        />
                    </div> */}
                    
                    <div className="input-container">
                        <label>Estado del Usuario</label>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '10px',
                            padding: '0.75rem 1rem',
                            border: '2px solid var(--border-color)',
                            borderRadius: 'var(--border-radius)',
                            backgroundColor: '#f8f9fa'
                        }}>
                            <input 
                                type="checkbox" 
                                id="activo-checkbox"
                                checked={activo} 
                                onChange={(e) => { setActivo(e.target.checked) }}
                                style={{ transform: 'scale(1.2)' }}
                            />
                            <label htmlFor="activo-checkbox" style={{ margin: 0, fontWeight: 'normal' }}>
                                Usuario Activo
                            </label>
                        </div>
                    </div>

                    {/* Campos para administrativos */}
                    {/* {esOperador.code == 2 && (
                        <>
                            
                            <div className="input-container conditional-field">
                                <label htmlFor="edit-nombre-input">Nombre Completo <span className="required-asterisk">*</span></label>
                                <InputText 
                                    id="edit-nombre-input"
                                    value={nombre} 
                                    onChange={(e) => { setNombre(e.target.value) }}
                                    placeholder="Ingrese el nombre completo"
                                />
                            </div>
                            
                            <div className="input-container conditional-field">
                                <label htmlFor="edit-email-input">Correo Electrónico <span className="required-asterisk">*</span></label>
                                <InputText 
                                    id="edit-email-input"
                                    type="email" 
                                    value={email} 
                                    onChange={(e) => { setEmail(e.target.value) }}
                                    placeholder="usuario@ejemplo.com"
                                />
                            </div>
                            
                  
                            <div className="input-container conditional-field">
                                <label htmlFor="edit-password-plataformas-input">Password Plataformas</label>
                                <InputText 
                                    id="edit-password-plataformas-input"
                                    type="password"
                                    value={passMonitor} 
                                    onChange={(e) => { setPassMonitor(e.target.value) }}
                                    placeholder="Contraseña para plataformas"
                                />
                            </div>
                            
                            <div className="input-container conditional-field">
                                <label htmlFor="edit-password-suma-input">Password Suma en Línea</label>
                                <InputText 
                                    id="edit-password-suma-input"
                                    type="password"
                                    value={passSumaEnLinea} 
                                    onChange={(e) => { setPassSumaEnLinea(e.target.value) }}
                                    placeholder="Contraseña para Suma en Línea"
                                />
                            </div>
                            
               
                            <div className="input-container conditional-field">
                                <InputCalendario 
                                    obligatorio 
                                    titulo={'Fecha de Nacimiento'} 
                                    value={fechaNacimiento} 
                                    onChange={(e) => { setFechaNacimiento(e.target.value) }}
                                />
                            </div>
                            
                            <div className="input-container conditional-field">
                                <InputLista 
                                    placeholder={lineasTelefonoPlaceholder} 
                                    options={lineasTelefonos} 
                                    value={lineasTelefono} 
                                    onChange={(e) => { setLineasTelefono(e.value) }} 
                                    titulo={"Número de Celular"}
                                />
                            </div>
                        </>
                    )} */}
                    
                    {/* Para operativos - Solo email y celular */}
                    {esOperador.code == 1 && (
                        <>
                            <div className="input-container conditional-field">
                                <label htmlFor="edit-email-operativo-input">Correo Electrónico <span className="required-asterisk">*</span></label>
                                <InputText 
                                    id="edit-email-operativo-input"
                                    type="email" 
                                    value={email} 
                                    onChange={(e) => { setEmail(e.target.value) }}
                                    placeholder="usuario@ejemplo.com"
                                />
                            </div>
                            
                            <div className="input-container conditional-field">
                                <InputLista 
                                    placeholder={lineasTelefonoPlaceholder} 
                                    options={lineasTelefonos} 
                                    value={lineasTelefono} 
                                    onChange={(e) => { setLineasTelefono(e.value) }} 
                                    titulo={"Número de Celular"}
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="modal-buttons-tablaPersonal">
                    <Button 
                        className="p-button-secondary"
                        icon="pi pi-times"
                        onClick={() => { setVisibleEditar(false); limpiarCampos() }}
                    >
                        Cancelar
                    </Button>
                    <Button 
                        icon="pi pi-check"
                        onClick={() => { actualizarUsuario() }}
                        disabled={
                            !email || 
                            (esOperador.code == 2 && (!nombre || !fechaNacimiento))
                        }
                    >
                        Actualizar Usuario
                    </Button>
                </div>
            </Dialog>
        </div>

    );
}

